import { render, staticRenderFns } from "./CampaignName.ts.vue?vue&type=template&id=f93633c2"
import script from "./CampaignName.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignName.ts.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports